/** Pick a fixed number of representative points from a PCV preview buffer. */
export function subsamplePcvPositions(
  positions: Float32Array,
  sourceCount: number,
  targetCount: number,
): { positions: Float32Array; count: number } {
  const n = Math.max(1, Math.min(targetCount, sourceCount));
  if (n >= sourceCount) {
    return { positions: positions.slice(0, sourceCount * 3), count: sourceCount };
  }
  const out = new Float32Array(n * 3);
  const step = sourceCount / n;
  for (let i = 0; i < n; i++) {
    const src = Math.min(sourceCount - 1, Math.floor(i * step + step * 0.5));
    const s3 = src * 3;
    const d3 = i * 3;
    out[d3] = positions[s3]!;
    out[d3 + 1] = positions[s3 + 1]!;
    out[d3 + 2] = positions[s3 + 2]!;
  }
  return { positions: out, count: n };
}

/** World silhouette points (stacked under grid cells). */
export const ENTRANCE_DOT_COUNT = 6400;
/** Each on-screen grid dot represents this many world points at morph time. */
export const DOTS_PER_GRID_CELL = 10;
export const GRID_CELL_COUNT = ENTRANCE_DOT_COUNT / DOTS_PER_GRID_CELL;
